import axios from "axios";
import {getPrivateURL, getPublicURL} from "./core.service";
import {applyAuthorizationHeader} from "./http-auth.service";

// axios.defaults.withCredentials = true;

applyAuthorizationHeader(axios);

export const getDashboard = (filter) => {
  console.log("Filter in request is " + filter)
  return axios.get(`${getPrivateURL()}dashboard`);
};


const DashboardService = {
  getDashboard,
};
export default DashboardService;
